import { t } from 'i18next'
import { Dropdown } from 'primereact/dropdown'
import React, { useEffect, useState } from 'react'
import { API_GRADE_SCHEMAS } from '../../../../../constants'
import { GradeSchema } from '../../../../../model/apprenticeModuleGrade.model'
import { RequestMethod } from '../../../../../model/enums/enums'
import { setGradeSchemas } from '../../../../../redux/basic/grade-schema/gradeSchemaActions'
import { removeGradeSchemas } from '../../../../../redux/basic/grades/grade-schema/gradeSchemaAction'
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks'
import { handleRequest } from '../../../../../services/api/base/handleRequest'

export const GradeSchemaDropdown = (props: {
  selectedId: number
  setSelected: (schema: GradeSchema) => void
}) => {
  const gradeSchemas = useAppSelector((state) => state.gradeSchemas)
  const dispatcher = useAppDispatch()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    const loadGradeSchemas = async () => {
      const result = await handleRequest<GradeSchema[]>(
        API_GRADE_SCHEMAS(),
        RequestMethod.GET
      )
      if (result.data && !result.error) {
        dispatcher(removeGradeSchemas())
        dispatcher(setGradeSchemas(result.data))
        // set the default to swiss
        props.setSelected(result.data[1])
      } else {
        console.warn('[GradeSchemaDropdown] Failed to load grade schemas.')
      }
    }
    if (gradeSchemas.length === 0 && !isLoading) {
      setIsLoading(true)
      loadGradeSchemas().finally(() => setIsLoading(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const itemTemplate = (schema: GradeSchema): JSX.Element => {
    if (!schema) {
      return <span>{t<string>('core.select')}</span>
    }
    return (
      <>
        <b>
          {t<string>(`grade_module.grade.schema.${schema.grade_schema_id}`)}
        </b>
        <span className={' ml-2 secondary-text'}>
          {t<string>(
            `grade_module.grade.schema.description.${schema.grade_schema_id}`
          )}
        </span>
      </>
    )
  }

  const getSelectedSchema = (id: number | undefined) => {
    if (id && id > 0) {
      const schema = gradeSchemas?.find((gs) => gs.grade_schema_id === id)
      if (schema) {
        return schema
      }
    }
    return gradeSchemas?.find((gs) => gs.grade_schema_id === 2)
  }

  return (
    <Dropdown
      id={'gradeSchemaDropdown'}
      value={getSelectedSchema(props.selectedId)}
      optionLabel={t<string>(`grade_module.grade.schema.${props.selectedId}`)}
      itemTemplate={itemTemplate}
      emptyMessage={t<string>('core.empty_message')}
      valueTemplate={
        props.selectedId
          ? () => (
              <span>
                {t<string>(`grade_module.grade.schema.${props.selectedId}`)}
              </span>
            )
          : t<string>('core.empty_message')
      }
      className={'w-full'}
      onChange={(e) => props.setSelected(e.value)}
      options={gradeSchemas}
    />
  )
}